import styled from "styled-components";
import { AreaButton } from "@/main/components/shared/styles";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const CustomAreaButton = styled(AreaButton)`
	margin: -3.5rem 0 0 auto;
	top: 3rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		margin: -1rem auto 1rem 0;
	}
`;

export const CardArea = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
	gap: 1rem;

	padding: 1rem;

	background: #ffffff;

	@media (max-width: 560px) {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		justify-items: center;
		padding: 0;
		gap: 0.2rem;
		width: 100%;
	}
`;
export const DateContainer = styled.div`
	display: flex;

	background: #fff;
	border-radius: 0.5rem;

	align-items: center;
	justify-content: space-around;
	gap: 6px;
	padding: 0 3px;

	& .MuiFormControl-root {
		width: 100%;
	}

	@media (max-width: 560px) {
		flex-direction: column;
		& .MuiFormControl-root {
			width: 100%;
			margin: 0.25rem 0rem;
		}
	}
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const TitleModal = styled.h6`
	font-weight: bold;
	font-size: 1.425rem;

	margin-bottom: 2rem;
`;
